const HTML = document.querySelector('html');

export default class Popup {
  constructor(elt, callbackClose = false) {
    this.elt = elt;
    this.callbackClose = callbackClose;

    // Init trigger click close
    const close = this.elt.querySelector('.trigger-close');
    if( close ) {
      close.addEventListener('click', (e) => {
        this.close(e)
      });
    }

    this.elt.addEventListener('click', (e) => {
      if( !e.target.classList.contains('popup__content') &&
          !e.target.closest('.popup__content')
        ) {
          this.close(e);
        }
    })
  }

  show() {
    this.elt.classList.add('show')
    HTML.classList.add('show-popup')
  }

  close(e) {
    e.stopPropagation();
    e.preventDefault();

    this.elt.classList.remove('show')
    HTML.classList.remove('show-popup');
    if(document.querySelector('.iframe-video-wrp')) {
      document.querySelector('.iframe-video-wrp iframe').contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
    }
    
    if( typeof this.callbackClose == 'function' ) {
      this.callbackClose.call();
    }
  }
}
